<script setup lang="ts">
  import { computed } from 'vue'

  const props = withDefaults(
    defineProps<{
      size?: number
    }>(),
    { size: 24 }
  )

  // Unique ID per instance to avoid SVG clipPath collisions
  let counter = 0
  const id = `spinner-${++counter}-${Math.random().toString(36).slice(2, 8)}`
  const clipId = computed(() => `${id}-clip`)
</script>

<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin"
  >
    <g :clip-path="`url(#${clipId})`">
      <foreignObject
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style="
            background: conic-gradient(
              from 90deg,
              rgba(147, 51, 234, 1) 0deg,
              rgba(196, 196, 196, 0) 360deg
            );
            height: 100%;
            width: 100%;
          "
        />
      </foreignObject>
    </g>
    <defs>
      <clipPath :id="clipId">
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258
            5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM2.4 12C2.4 17.3019 6.69807
            21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4
            12 2.4C6.69807 2.4 2.4 6.69807 2.4 12Z"
        />
      </clipPath>
    </defs>
  </svg>
</template>
